import axios from 'axios'
import baseService from './baseService'
import inventoryData from './data/inventory'

const inventoryService = {
  getSupplierInventoryInformation (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(inventoryData.all.find((x) => x.id === 1))
      } else {
        axios
          .get('inventory/supplier/getinventoryinformation', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  },
  getCustomerInventoryInformation (token) {
    return new Promise((resolve, reject) => {
      if (baseService.isTestMode) {
        resolve(inventoryData.all.find((x) => x.id === 1))
      } else {
        axios
          .get('inventory/customer/getinventoryinformation', { params: { token: token } }, baseService.defaultConfig)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error.response.data)
          })
      }
    })
  }

}

export default inventoryService
